import addMonths from 'date-fns/addMonths';
import dateFormattter from 'date-fns/format';
import isFuture from 'date-fns/isFuture';

import type { IDateService } from 'v2/interfaces/date';

export class DateService implements IDateService {
  isFutureDate(date: Date): boolean {
    return isFuture(date);
  }

  stringToDate(stringDate: string): Date {
    return new Date(stringDate);
  }

  dateToString(date: Date, format = 'yyyy-MM-dd'): string {
    return dateFormattter(date, format);
  }

  addMonths(date: Date, months: number): Date {
    return addMonths(date, months);
  }
}

export const dateService = new DateService();
